
/*
 CONVERT global to local coordinates

 WARNING :
 let isBuggy = false; --> To test on all browsers

 function convertPointFromPageToNode(element, event.pageX, event.pageY) -> {x, y}
 return coordinate in elements local coordinate system (works properly with css transforms without perspective projection)

 see https://bugzilla.mozilla.org/show_bug.cgi?id=591718
 */
(function () {
    "use strict";

    function Point(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
    }

    function CSSMatrix(s) {
        let m = null;
        if (typeof s === "string") {
            let c = s.match(/matrix3?d?\(([^\)]+)\)/i)[1].split(',');
            if (c.length === 6) {
                c = [c[0], c[1], 0, 0, c[2], c[3], 0, 0, 0, 0, 1, 0, c[4], c[5], 0, 1];
            }
            m = [];
            let i = -1;
            while (++i < 4) {
                let j = -1;
                while (++j < 4) {
                    m[i * 4 + j] = parseFloat(c[j * 4 + i]);
                }
            }
        } else {
            m = s;
        }
        this.data = m;
    }

    CSSMatrix.prototype = {
        multiply: function (m) {
            let a = this.data;
            let b = m.data;
            let r = [];
            let i = -1;
            while (++i < 4) {
                let j = -1;
                while (++j < 4) {
                    let t = 0;
                    let k = -1;
                    while (++k < 4) {
                        t += a[i * 4 + k] * b[k * 4 + j];
                    }
                    r[i * 4 + j] = t;
                }
            }
            return new CSSMatrix(r);
        },
        translate: function (tx, ty, tz) {
            let z = new CSSMatrix([1, 0, 0, tx, 0, 1, 0, ty, 0, 0, 1, tz, 0, 0, 0, 1]);
            return this.multiply(z);
        },
        inverse: function () {
            let m = this.data;
            let a = m[0 * 4 + 0];
            let b = m[0 * 4 + 1];
            let c = m[0 * 4 + 2];
            let d = m[1 * 4 + 0];
            let e = m[1 * 4 + 1];
            let f = m[1 * 4 + 2];
            let g = m[2 * 4 + 0];
            let h = m[2 * 4 + 1];
            let k = m[2 * 4 + 2];
            let A = e * k - f * h;
            let B = f * g - d * k;
            let C = d * h - e * g;
            let D = c * h - b * k;
            let E = a * k - c * g;
            let F = b * g - a * h;
            let G = b * f - c * e;
            let H = c * d - a * f;
            let K = a * e - b * d;
            let det = a * A + b * B + c * C;
            let X = new CSSMatrix([A / det, D / det, G / det, 0,
                B / det, E / det, H / det, 0,
                C / det, F / det, K / det, 0,
                0,       0,       0, 1]);
            let Y = new CSSMatrix([1, 0, 0, -m[0 * 4 + 3],
                0, 1, 0, -m[1 * 4 + 3],
                0, 0, 1, -m[2 * 4 + 3],
                0, 0, 0,            1]);
            return X.multiply(Y);
        },
        transformPoint: function (p) {
            let m = this.data;
            return new Point(m[0 * 4 + 0] * p.x + m[0 * 4 + 1] * p.y + m[0 * 4 + 2] * p.z + m[0 * 4 + 3],
                m[1 * 4 + 0] * p.x + m[1 * 4 + 1] * p.y + m[1 * 4 + 2] * p.z + m[1 * 4 + 3],
                m[2 * 4 + 0] * p.x + m[2 * 4 + 1] * p.y + m[2 * 4 + 2] * p.z + m[2 * 4 + 3]);
        }
    };

    let isBuggy = false;
    let initialized = false;

    let buggy = function (doc) {
        if (initialized) {
            return isBuggy;
        }
        initialized = true;
        let div = doc.createElement('div');
        div.style.cssText = 'width:200px;height:200px;position:fixed;-moz-transform:scale(2);';
        doc.body.appendChild(div);
        let rect = div.getBoundingClientRect();
        isBuggy = !!(getComputedStyle(div, null).MozTransform && (rect.bottom - rect.top < 300));
        div.parentNode.removeChild(div);
        return isBuggy;
    };

    function getTransformationMatrix(element) {
        let identity = new CSSMatrix('matrix(1,0,0,1,0,0)');
        let transformationMatrix = identity;
        let x = element;
        let rect = null;
        //let isBuggy = buggy(x.ownerDocument);
        let isBuggy = false; // TO TEST ON ALL BROWSERS

        while (x !== null && x !== x.ownerDocument.documentElement) {
            let computedStyle = window.getComputedStyle(x, null);
            let c = new CSSMatrix((computedStyle.OTransform || computedStyle.WebkitTransform || computedStyle.msTransform ||  computedStyle.MozTransform || 'none').replace(/^none$/, 'matrix(1,0,0,1,0,0)'));

            if (isBuggy) {
                // origin and t matrices are required only for Firefox (buggy getBoundingClientRect)
                rect = x.getBoundingClientRect();
                let parentRect = x.parentNode !== null && x.parentNode.getBoundingClientRect ? x.parentNode.getBoundingClientRect() : rect;
                let t = identity.translate(rect.left - parentRect.left, rect.top - parentRect.top, 0);

                let origin = computedStyle.OTransformOrigin || computedStyle.WebkitTransformOrigin || computedStyle.msTransformOrigin || computedStyle.MozTransformOrigin || '';
                // Firefox gives "50% 50%" when there is no transform
                origin = origin.indexOf('%') !== -1 ? '' : origin;
                origin = new CSSMatrix('matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,' + ((origin || '0 0') + ' 0').split(' ').slice(0, 3) + ',1)');

                // transformationMatrix = t * origin * c * origin^-1 * transformationMatrix
                //let inverseOrigin = translate(identity, -origin[0 * 4 + 3], -origin[1 * 4 + 3], -origin[2 * 4 + 3]);
                let inverseOrigin = origin.inverse();
                transformationMatrix = t.multiply(origin).multiply(c).multiply(inverseOrigin).multiply(transformationMatrix);
            } else {
                transformationMatrix = c.multiply(transformationMatrix);
            }

            x = x.parentNode;
        }

        if (!isBuggy) {
            let w = element.offsetWidth;
            let h = element.offsetHeight;
            let i = 4;
            let left = +Infinity;
            let top = +Infinity;
            while (--i >= 0) {
                let p = transformationMatrix.transformPoint(new Point(i === 0 || i === 1 ? 0 : w, i === 0 || i === 3 ? 0 : h, 0));
                if (p.x < left) {
                    left = p.x;
                }
                if (p.y < top) {
                    top = p.y;
                }
            }
            rect = element.getBoundingClientRect();

            transformationMatrix = identity.translate(window.pageXOffset + rect.left - left, window.pageYOffset + rect.top - top, 0).multiply(transformationMatrix);
        }

        return transformationMatrix;
    }

    window.convertPointFromPageToNode = function (element, pageX, pageY) {
        return getTransformationMatrix(element).inverse().transformPoint(new Point(pageX, pageY, 0));
    };


    function isInt(n)
    {
        return !isNaN(n) && Number(n) === n && n % 1 === 0;
    };

    // TODO : filter only elements with ".element" class
    /*window.elementsFromPoint = function(x,y) {

        let elements = [];

        x = parseInt(x);
        y = parseInt(y);

        if (!isInt(x) || !isInt(y))
            return elements;

        if (document.elementsFromPoint) // Chrome
            elements = document.elementsFromPoint(x, y);
        else
        if (document.elementFromPoint)
        {
            let previousPointerEvents = [], current, i, d;

            // get all elements via elementFromPoint, and remove them from hit-testing in order
            while ((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1 && current != null) {

                // push the element and its current style
                elements.push(current);
                previousPointerEvents.push({
                    value: current.style.getPropertyValue('pointer-events'),
                    priority: current.style.getPropertyPriority('pointer-events')
                });

                // add "pointer-events: none", to get to the underlying element
                current.style.setProperty('pointer-events', 'none', 'important');
            }

            // restore the previous pointer-events values
            for (i = previousPointerEvents.length; d = previousPointerEvents[--i];) {
                elements[i].style.setProperty('pointer-events', d.value ? d.value : '', d.priority);
            }
        }
        else
        if (document.msElementsFromRect && document.msElementsFromRect(x, y, 1, 1)){ // IE
            let nodes = document.msElementsFromRect(x, y, 1, 1)
            for(let i = nodes.length; i--; elements.unshift(nodes[i]));
        }

        //    elements.sort(function(a, b) {
        // return(Number(a.style.zIndex) - Number(b.style.zIndex));
        // }); 

        return elements;

}*/
})();